import { baseApi } from '@/store/api/baseApi';
import type { DashboardData, DashboardQueryParams } from '@/types/dashboard';

function buildDashboardQuery(params?: DashboardQueryParams): string {
  const searchParams = new URLSearchParams();
  if (params?.dateFrom) searchParams.set('dateFrom', params.dateFrom);
  if (params?.dateTo) searchParams.set('dateTo', params.dateTo);
  if (params?.groupBy) searchParams.set('groupBy', params.groupBy);
  if (params?.limit != null) searchParams.set('limit', String(params.limit));
  const query = searchParams.toString();
  return query ? `?${query}` : '';
}

export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query<DashboardData, DashboardQueryParams | void>({
      query: (params) => `/dashboard${buildDashboardQuery(params ?? undefined)}`,
      serializeQueryArgs: ({ endpointName, queryArgs }) =>
        `${endpointName}(${buildDashboardQuery(queryArgs ?? undefined).replace('?', '')})`,
      forceRefetch: ({ currentArg, previousArg }) =>
        buildDashboardQuery(currentArg ?? undefined) !==
        buildDashboardQuery(previousArg ?? undefined),
      providesTags: [{ type: 'Dashboard', id: 'OVERVIEW' }],
    }),
  }),
});

export const { useGetDashboardQuery } = dashboardApi;
